import { render, staticRenderFns } from "./AgencyUsers.vue?vue&type=template&id=456c928f&"
import script from "./AgencyUsers.vue?vue&type=script&lang=ts&"
export * from "./AgencyUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports